module.exports = __webpack_public_path__ + "media/images/talent/vector-blob-7b598ed2e1a8e964089e4d3ebb51a632.svg";